import React from 'react';
import { Link } from 'react-router-dom';
import { PenLine, ArrowRight } from 'lucide-react';
import PageLayout, { PageHero } from '../components/PageLayout';

const TOPICS = [
  { accent: 'accent-1', title: 'Outbound operations', desc: 'How to run high-volume calling campaigns without burning out your agents.' },
  { accent: 'accent-5', title: 'Mobile-first sales',  desc: 'Why Android phones are replacing desk phones in modern call centers.' },
  { accent: 'accent-4', title: 'Agent productivity',  desc: 'Auto dialing, talk-time ratios, and what actually moves the needle.' },
];

const Blog = () => (
  <PageLayout
    title="Blog — Mobile Call Center & Outbound Calling Insights"
    description="Articles on outbound calling strategy, mobile-first operations, agent productivity, and building better call center teams. Insights from the WASLX team."
    path="/blog"
  >
    <PageHero
      eyebrow="Blog"
      accent="accent-5"
      title={
        <>
          Thoughts from the <span className="display-accent">WASLX team</span>
        </>
      }
      sub="We are heads-down building right now. Our first posts — on outbound calling, mobile-first operations and sales productivity — are coming soon."
    />

    <section className="section section--muted">
      <div className="container-page">
        <div className="mx-auto max-w-3xl">
          <div className="accent-5 empty-state">
            <span className="shape shape--blob shape--md shape--br" aria-hidden="true" />
            <span className="icon-tile icon-tile--lg">
              <PenLine className="h-6 w-6" />
            </span>
            <h2 className="empty-state__title">First post coming soon</h2>
            <p className="empty-state__sub">
              We will be writing about building a call center on Android, what makes outbound sales
              teams win, and what we are learning in beta.
            </p>
            <Link to="/contact" className="btn-pill btn-pill--primary mt-2">
              Get notified when we publish
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="mt-12">
            <p className="mb-5 text-center text-2xs font-bold uppercase tracking-[0.12em] text-content-muted">
              Topics we will cover
            </p>
            <div className="stagger-children grid gap-4 sm:grid-cols-3">
              {TOPICS.map(topic => (
                <div
                  key={topic.title}
                  className={`${topic.accent} card card--hover animate-fade-up`}
                >
                  <h3 className="card-title">{topic.title}</h3>
                  <p className="card-body">{topic.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default Blog;
